import script from "./QuestionsPreviewComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionsPreviewComponent.vue?vue&type=script&setup=true&lang=js"

import "./QuestionsPreviewComponent.vue?vue&type=style&index=0&id=0be077c7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0be077c7"]])

export default __exports__